import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenAuthenticationEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    login() {
        return `${this.getApiServerUrl()}/login`;
    }

    signUp() {
        return `${this.getApiServerUrl()}/signup`;
    }

    forgottenPassword() {
        return `${this.getApiServerUrl()}/forgotten-password`;
    }

    forgottenPasswordReset() {
        return `${this.getApiServerUrl()}/forgotten-password/reset`;
    }

    forgottenPasswordTokenCheck(token: string) {
        return `${this.getApiServerUrl()}/forgotten-password/token/${token}`;
    }
}
